/**
 * GLOBAL CONFIGURATION REDUCER
 * 获取并设置全局配置信息
 * 当前用户 token
 * 后端服务地址
 * ...
 */
import { PayloadAction } from '@reduxjs/toolkit'

const initialState = {}
export { initialState as ConfigState }

export default function configurationReducer(
    config = initialState, action: PayloadAction<any>
): typeof initialState {
    switch (action.type) {
      case 'some type': {
        return action.payload
      }
      default:
        return config
    }
}
export type ConfigType = ReturnType<typeof configurationReducer>
